"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-underscore-dangle */
function parseCampaignData(conversions, plasmaJoins, rewards) {
  var users = {};
  var parsedRevJoines = {};
  var campaignLastActivity = 0;
  var conversionId;
  conversions.forEach(function (conversion) {
    if (users[conversion._participate.id] == null) {
      users[conversion._participate.id] = {
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0,
        joins: [],
        conversions: [],
        statusByConversions: {}
      };
    }

    conversionId = conversion._conversionId;

    if (conversionId) {
      users[conversion._participate.id].conversions.push(conversionId);

      users[conversion._participate.id].statusByConversions[conversionId] = {
        status: conversion._status,
        rejectedAt: conversion._rejected_at || conversion._updatedTimeStamp,
        rejectedStatusCode: conversion._rejected_status_code
      };
      users[conversion._participate.id].paid = users[conversion._participate.id].paid || conversion._paid;
    } // eslint-disable-next-line radix


    users[conversion._participate.id].conversionEthAmount += conversion._ethAmountSpent / Math.pow(10, 18);
    users[conversion._participate.id].tokensBought += conversion._tokens / Math.pow(10, 18);
    users[conversion._participate.id].conversionTimestamp = Math.max(users[conversion._participate.id].conversionTimestamp, parseInt(conversion._timeStamp, 10) || 0);
    users[conversion._participate.id].amountConverterSpentETH += conversion._ethAmountSpent / Math.pow(10, 18);
    users[conversion._participate.id].amountConverterSpentFIAT += conversion._fiatAmountSpent / Math.pow(10, 18); // eslint-disable-next-line max-len

    users[conversion._participate.id].lastConversionTimestamp = users[conversion._participate.id].lastConversionTimestamp > conversion._timeStamp ? users[conversion._participate.id].lastConversionTimestamp : conversion._timeStamp;
    users[conversion._participate.id].userCreationTimestamp = conversion._participate._timeStamp;
    campaignLastActivity = conversion._timeStamp > campaignLastActivity ? conversion._timeStamp : campaignLastActivity;

    if (users[conversion._participate.id].userRegInfo == null) {
      users[conversion._participate.id].userRegInfo = {
        _email: conversion._participate._email,
        _fullName: conversion._participate._fullName,
        _name: conversion._participate._name,
        _walletName: conversion._participate._walletName,
        _handle: null
      };
    }
  });
  plasmaJoins.forEach(function (join) {
    campaignLastActivity = join._timeStamp > campaignLastActivity ? join._timeStamp : campaignLastActivity;

    if (parsedRevJoines[join._visitor.id] == null) {
      parsedRevJoines[join._visitor.id] = join._referrer.id;
    }

    if (users[join._referrer.id] == null) {
      users[join._referrer.id] = {
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0,
        joins: []
      };
    }

    users[join._referrer.id].userCreationTimestamp = join._referrer._timeStamp;

    users[join._referrer.id].joins.push(join._visitor.id);

    if (users[join._visitor.id] == null) {
      users[join._visitor.id] = {
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0,
        joins: []
      };
    }

    users[join._visitor.id].userCreationTimestamp = join._visitor._timeStamp;
    users[join._visitor.id].userJoinCampaignTimestamp = join._timeStamp;
  });
  rewards.forEach(function (reward) {
    campaignLastActivity = reward._timeStamp > campaignLastActivity ? reward._timeStamp : campaignLastActivity;

    if (users[reward._user.id] == null) {
      users[reward._user.id] = {
        joins: [],
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0,
        userCreationTimestamp: reward._user._timeStamp
      };
    }

    users[reward._user.id].reward += reward._amount / Math.pow(10, 18);
    users[reward._user.id].lastRewardTimestamp = Math.max(users[reward._user.id].lastRewardTimestamp || 0, parseInt(reward._timeStamp, 10) || 0);

    if (users[reward._user.id].userRegInfo == null) {
      users[reward._user.id].userRegInfo = {
        _email: reward._user._email,
        _fullName: reward._user._fullName,
        _name: reward._user._name,
        _walletName: reward._user._walletName,
        _handle: null
      };
    }
  });
  return [parsedRevJoines, users, campaignLastActivity];
}

function visitedListFromGraphToHashMap(firstReferreInfo, visits, revJoins, _users, campaignLastActivityAfterPublicResponse) {
  var edges = {};

  var users = _objectSpread({}, _users);

  var campaignLastActivity = campaignLastActivityAfterPublicResponse;
  var visitsSubstruction = 0;
  visits.forEach(function (edge) {
    campaignLastActivity = edge._timeStamp > campaignLastActivity ? edge._timeStamp : campaignLastActivity;

    if (!users[edge._referrer.id]) {
      users[edge._referrer.id] = {
        joins: [],
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0,
        timestamp: edge._referrer._timeStamp > edge._timeStamp ? edge._referrer._timeStamp : edge._timeStamp
      };
    } // eslint-disable-next-line max-len


    users[edge._referrer.id].userCreationTimestamp = users[edge._referrer.id].userCreationTimestamp < edge._referrer._timeStamp ? users[edge._referrer.id].userCreationTimestamp : edge._referrer._timeStamp;

    if (!users[edge._referrer.id].userRegInfo) {
      users[edge._referrer.id].userRegInfo = {
        _email: null,
        _fullName: null,
        _name: null,
        _walletName: null,
        _handle: edge._referrer._handle
      };
    } else {
      users[edge._referrer.id].userRegInfo._handle = edge._referrer._handle;
    }

    if (!users[edge._visitor.id]) {
      users[edge._visitor.id] = {
        joins: [],
        tokensBought: 0,
        lastRewardTimestamp: 0,
        conversionTimestamp: 0,
        conversionsFiatAmount: 0,
        conversionEthAmount: 0,
        amountConverterSpentETH: 0,
        amountConverterSpentFIAT: 0,
        reward: 0
      };
    } // console.log(users);


    users[edge._visitor.id].userJoinCampaignTimestamp = edge._timeStamp; // eslint-disable-next-line max-len

    users[edge._visitor.id].userCreationTimestamp = users[edge._visitor.id].userCreationTimestamp < edge._visitor._timeStamp ? users[edge._visitor.id].userCreationTimestamp : edge._visitor._timeStamp;

    if (!users[edge._visitor.id].userRegInfo) {
      users[edge._visitor.id].userRegInfo = {
        _email: null,
        _fullName: null,
        _name: null,
        _walletName: null,
        _handle: edge._visitor._handle
      };
    } else {
      users[edge._visitor.id].userRegInfo._handle = edge._visitor._handle;
    } // Visits:


    if (!edges[edge._referrer.id]) {
      edges[edge._referrer.id] = [];
    }

    if (revJoins[edge._visitor.id]) {
      if (revJoins[edge._visitor.id] === edge._referrer.id) {
        edges[edge._referrer.id].push(edge._visitor.id);
      } else {
        visitsSubstruction++;
      }
    } else {
      edges[edge._referrer.id].push(edge._visitor.id);
    }
  });
  users[firstReferreInfo.referrer].userJoinCampaignTimestamp = firstReferreInfo.firstCampaignActivity;
  return [edges, users, campaignLastActivity, visitsSubstruction];
}

module.exports.parseCampaignData = parseCampaignData;
module.exports.visitedListFromGraphToHashMap = visitedListFromGraphToHashMap;